import { CDN_BASE_URL } from './config';

export function getMediaUrl(path: string | null | undefined): string | undefined {
  if (!path) {
    return undefined;
  }

  // Already a full URL — return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (!CDN_BASE_URL) {
    throw new Error('getMediaUrl: VITE_CDN_BASE_URL is not defined');
  }

  return `${CDN_BASE_URL}${path}`;
}
